const $ = require("jquery");

declare const PinUtils: any;

export function Pinterest(
  this: any,
  id: string,
  containerSelector: string,
  url: string,
  embedType: string,
) {
  "use strict";
  var pinterest = this;

  pinterest.id = id;
  pinterest.url = url;
  pinterest.embedType = embedType;
  pinterest.$container = $(containerSelector);
  pinterest.$pinLink = pinterest.$container.children("a");
  pinterest.$block = pinterest.$container.parents(".sb-block");

  pinterest.prevHeight = parseInt(
    pinterest.$container.attr("data-pin-height"),
    10,
  );
  pinterest.prevWidth = parseInt(
    pinterest.$container.attr("data-pin-width"),
    10,
  );
}

Pinterest.prototype.build = function () {
  "use strict";
  var pinterest = this;

  pinterest.setSize();

  pinterest.$block.on("schoolblocks.resize", pinterest.setSize.bind(pinterest));
  $(window).on("resize", pinterest.setSize.bind(pinterest));
};

Pinterest.prototype.setSize = function () {
  "use strict";
  var pinterest = this,
    blockHeight = pinterest.$block.height(),
    blockWidth = pinterest.$block.width(),
    $origPin;

  if (
    pinterest.$pinLink.length === 0 ||
    pinterest.prevHeight !== blockHeight ||
    pinterest.prevWidth !== blockWidth
  ) {
    $origPin = $("<a></a>");
    $origPin.attr("id", "pin_" + pinterest.id);
    $origPin.attr("href", pinterest.url);
    $origPin.attr("data-pin-do", pinterest.embedType);
    $origPin.attr("data-pin-height", blockHeight);
    $origPin.attr("data-pin-width", blockWidth);
    $origPin.attr("data-pin-columns", Math.ceil(blockWidth / 237));

    pinterest.prevHeight = blockHeight;
    pinterest.prevWidth = blockWidth;

    // The pin was already built and might need to be rebuilt
    pinterest.$container.empty().append($origPin);

    PinUtils.build(document.getElementById("#" + $origPin.attr("id")));
  }
};
